<template>
  <div class="content">
    <p style="font-weight: 400;">财运亨通用户协议</p>
<p style="font-weight: 400;">感谢选择财运亨通为您提供服务！</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">《财运亨通用户协议》（以下简称&ldquo;本协议&rdquo;）是由财通证券股份有限公司（以下简称&ldquo;财通证券&rdquo;）就财运亨通APP平台（以下简称&ldquo;平台&rdquo;）相关服务事项和您签订。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">协议确认</p>
<p style="font-weight: 400;"><strong>1.1您在登录平台过程中点击同意协议，即表示自愿申请使用平台各项服务，且完全同意并接受本协议。本协议对双方具有合同法律效力。</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>1.2在接受本协议之前，您应仔细阅读并理解本协议（特别是以粗体标注的内容）。如果您不同意本协议的任何内容，或者无法准确理解条款，请不要进行后续操作。</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>1.3如本协议发生变更，平台将通过平台公告方式提前予以公布，变更后的协议在公告期届满起生效。若您在协议生效后继续使用平台服务的，表示您接受变更后的协议，也将遵循变更后的协议使用平台服务。</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1.4本协议并非股权协议或证券开户协议，您使用具体服务时，仍需按要求签署相关协议。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1.5平台通知及平台页面出现的操作提示都是平台规则，所有规则为本协议不可分割的一部分，与本协议正文具有同等法律效力。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">平台登录</p>
<p style="font-weight: 400;">2.1您在登录、查询、使用平台时，应按平台要求提供您合法、真实、有效、完整且准确的身份信息，并在发生变更时及时主动更新，否则导致的一切纠纷、损失由您自行承担。<strong>如您占用他人的联系方式，应及时更换。</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>2.2您的身份信息包括但不限于您的手机号码、验证码、身份证件号、账户号等，任何使用您的身份信息进行的操作或指令，均视为您本人作出。</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;">2.3您首次登录平台，需输入您的手机号并进行短信验证。首次登录成功后，平台系统为您生成账号，您可以在该账号下设置昵称、头像等信息。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>2.4您应知悉，您首次登录平台成功并不等同拥有财通证券资金账户、证券账户或其他账户。</strong>您可以进一步在线申请开立上述账户，但以具体业务要求及页面提示为准。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>2.5基于信息安全考虑，当您在非交易登录、更换手机号码、卸载重装等情况下，平台有权采取短信验证码等验证措施识别您的身份，交易登录时会校验您的资金账户及密码信息。</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">平台服务</p>
<p style="font-weight: 400;">3.1财运亨通提供的服务包括但不限于股权服务、理财服务、企业服务等，并有权根据实际情况进行调整。财通证券有权将部分服务仅向符合监管要求的投资者提供（具体以监管要求及平台实际功能为准）。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3.2您通过平台进行理财产品购买等服务，均应遵守监管要求及业务规则。否则，平台有权拒绝为您提供服务且不承担任何责任。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>3.3对于</strong><strong>财运亨通</strong><strong>提供的收费服务，您应充分了解收费标准，并按财通证券公布的服务收费标准支付费用。</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>3.4您同意财通证券可以通过您的资金账户扣去相关费用。</strong>您应保证您的资金账户有足额资金支付，如您在费用扣款日账户余额不足以支付，财通证券将暂停对应的收费服务项目，直至您补足费用，且届时您须再次通过平台提交相应服务申请。因暂停提供服务造成的一切风险、损失等，由您自行承担。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3.5原免费项目调整为收费项目或收费标准发生变更的，平台将提前公告。您可以选择不继续使用，如您继续使用的情况下，资金余额不足以支付或拒绝支付费用的，财通证券有权暂停或终止为您提供服务。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3.6平台有权采取安全控制措施，包括但不限于必须输入短信验证码、单日连续输错密码则限制登录等。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3.7您应知晓，平台尽力提供优质服务，但不能保证完全避免服务异常（包括但不限于中断、停顿、延迟、数据错误等）。当出现以下情况，平台尽力避免服务异常或减少异常时间，但对此产生的服务异常不承担责任。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（1）因台风、地震、洪水等自然灾害或恐怖事件等不可抗力原因；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（2）定期或不定期进行系统维护、检修或升级；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（3）因网络运营商通信故障、互联网拥堵、网络恶意程序攻击、网络病毒、电力故障、银行原因等三方服务问题。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">平台管理</p>
<p style="font-weight: 400;">4.1您不得将平台服务用于任何非法用途，也不得以任何非法形式使用平台服务。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.2平台所有服务仅限您本人使用，不得以任何形式转让、赠与、继承或授权他人使用。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.3平台上所有内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网页设计等，均由财通证券依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。非经财通证券同意，任何人不得擅自使用、修改、复制、公开传播、反向编译、改发、散布、发行或公开发表平台的程序或内容。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.4您设置的账号昵称、头像等必须遵守法律法规、公序良俗、社会公德，且不会侵害第三方合法权益，否则平台将会取消您的昵称、头像等。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.5您在平台发表言论时，应不得违反相关法律法规及监管规定，并不得以任何方式发布、传播含有以下内容之一的信息：</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（1）违反宪法或法律法规规定的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（3）损害国家荣誉和利益的，损害公共利益的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（4）煽动民族仇恨、民族歧视、破坏民族团结的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（9）以非法民间组织名义活动的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（10）含有法律、行政法规禁止的其他内容。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.6为维护平台用户交流健康秩序，凡出现以下情况之一的，平台有权采取包括但不限于删除信息、限制功能、关闭账号等措施，且无需提前通知您。由此导致的一切责任与损失由您自行承担。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（1）含有上述4.5禁止的相关内容；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（2）以任何形式发布股票推荐、诱导或代理投资、资金借贷、信用卡套现等信息；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（3）含有网络病毒、诈骗信息、虚假信息的文字、链接、图片等；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（4）含有辱骂他人、胁迫他人、侵害他人隐私等内容；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（5）盗用他人信息、伪装他人身份；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（6）使用发帖机等非法软件进行爆屏、违规发表言论；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（7）以任何形式发布广告，包括但不限于网络兼职、代办证件、售卖考试答案、买卖发票、非法彩票等；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（8）发布空白或与所在主题不符的内容，或频繁重复发布；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（9）过于发泄情绪或使用粗俗字句；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（10）其它影响平台服务秩序的行为。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.7您同意，平台有权将您在平台发布的言论调整展示位置或推送首页。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>4.8您通过平台服务获得的虚拟积分，并非是您拥有所有权的财产。您应遵守平台规则使用积分，如平台发现您通过欺诈、不正当手段（包括但不限于恶意注册、扰乱系统、网络攻击、作弊领取等）获得积分或参与积分活动，平台有权要求您返还上述行为获得的活动收益，并采取限制功能、暂停服务、关闭账号等处理措施，并保留追究法律责任的权利。</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.9您参与平台活动，即表示您授权平台将您的身份信息用于管理此类活动，同时授权平台在必要时将您的手机号或账号脱敏后展示。如活动涉及第三方联合推广，平台有可能共享您活动中必要的个人信息。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>风险提示</strong></p>
<p style="font-weight: 400;"><strong>5.1平台向您展示信息不等同于财通证券向您提供证券投资咨询服务，您不应以平台信息作为投资决策依据，财通证券不对您据此作出的投资决策进行任何保证收益或不亏损的承诺。</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>5.2平台上刊载的所有资料及图表仅供您参考，不构成邀约或意图邀约您购买、抛售或持有任何产品、股份。您据此投资造成的盈亏与财通证券无关。</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>5.3平台上部分资讯信息、数据资料来源于第三方，平台不保证其准确性、真实性、完整性及原创性等，您自行承担因信赖或使用第三方信息而引致的任何损失。</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>5.4平台为用户提供发布言论功能，但不保证言论（包括但不限于文字、数据及图表）的准确性、真实性、有效性、原创性等，平台上的用户言论均与财通证券立场无关，不构成对您的任何投资建议，据此操作，风险自担。您应当提高自我保护意识，防范信息欺诈，不盲目偏信平台上的用户言论。</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>5.5财通证券严禁平台工作人员从事下述行为，您应充分知晓，并不得参与其中，否则由此造成的一切后果将由您自行承担。</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（1）代您作出投资决策；</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（2）以任何形式向您做出保证资产本金不受损失或者保证取得最低收益的承诺，或与您约定分享投资收益、分担投资亏损；</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（3）接受您的全权委托而决定证券交易方向、交易种类、交易数量或交易价格；</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（4）泄露财通证券商业秘密，泄露您投资交易情况、商业秘密或他人隐私；</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（5）通过个人账户或公司以外的其他账户向您收取服务费用，或以其他方式私下收取您任何款项或财务；</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（6）向您提供投资建议时，对证券价格涨跌或者市场走势做出确定性的判断；</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（7）以虚假信息、市场传言或内幕信息为依据向您提供投资分析、预测或建议；</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（8）法律法规、证券监管部门、行业自律组织禁止的其他行为。</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">通知</p>
<p style="font-weight: 400;">6.1您在使用平台服务，即表示同意接收平台内消息推送。如不愿意接收，您可在平台或手机消息管理中修改设置，具体以实际功能支持为准。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">6.2您同意财通证券根据您在平台填写的联系方式（包括但不限于手机号、地址、邮箱）向您发送电子形式的业务通知。该服务免费提供，除非财通证券存在故意或重大过失，否则对业务通知未能及时、准确发送给您带来的损失，财通证券不承担责任。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">6.3您应完全理解并自行承担无法及时收到通知的风险，可能由于您的软硬件设置、第三方干扰、通信运营商等外部原因，也可能由于您填写的信息错误、未及时更新等原因。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">6.4财通证券通过手机短信、信件、邮件、平台消息等发出通知的，通知发出即视为财通证券已履行通知义务。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>适用法律和管辖权</strong></p>
<p style="font-weight: 400;"><strong>本协议适用中华人民共和国法律。如出现纠纷，将交由浙江省杭州市西湖区人民法院管辖。</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">财通证券股份有限公司</p>

  <p>&nbsp;</p>
</div></template>

<script>
document.title = "财运亨通用户协议";
export default {
  name: "QctServiceProtocal",
  mounted: function () { },
  data: function () {
    return {
      // uaInfo: "",
    };
  },
};
</script>

<style scoped>.content {
  padding: 100px;
}

p {
  word-break: break-all;
}</style>
